import { trpc } from "../trpc";
import { useCallback } from "react";

interface Input {
  folderId: string;
}

interface GenerateAiNotesFromFolderAssetsOptions {
  debug?: boolean;
}

export function useGenerateAiNotesFromFolderAssets({ folderId }: Input) {
  const mutation = trpc.folder.generateAiNotesFromFolderAssets.useMutation();
  const { mutateAsync, isPending, error } = mutation;

  const generateAiNotesFromFolderAssets = useCallback(
    (options: GenerateAiNotesFromFolderAssetsOptions = {}) =>
      mutateAsync({
        folderId,
        ...options,
      }),
    [folderId, mutateAsync],
  );

  return {
    generateAiNotesFromFolderAssets,
    isGenerating: isPending,
    error,
  };
}
